(function($R)
{
    $R.add('plugin', 'makkati_mizo', {
        
        translations: {
    		en: {
    			"Makkati Mizo": "Makkati Mizo"
    		}
        },
        init: function(app)
        {
            this.app = app;
            this.lang = app.lang;
            this.opts = app.opts;
        },
        onpasting: function(code){
            code = code.replace(/\\/g, 'ṭ');
            code = code.replace(/\|/g, 'Ṭ');
            console.log(code);
            return code
        },
        onkeydown:function(e){
            if(e.keyCode == 220){
                e.preventDefault();
                if(e.shiftKey == true){
                    this.app.insertion.insertText('Ṭ')
                }else{
                    this.app.insertion.insertText('ṭ')
                }
            }
            
        }
    });
})(Redactor);